import React, {Component} from 'react';
import PropTypes, { array } from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import VentanaPrincipal from './VentanaPrincipal';
import RegistroOficio from './RegistroOficio';
import {Modal,Button} from 'react-bootstrap'
import AddIcon from '@material-ui/icons/Add';
import MoveToInboxIcon from '@material-ui/icons/MoveToInbox';
import Grid from '@material-ui/core/Grid';
import { UPDCTE } from '../../services/SecurityService';

const styles = theme => ({
    card: {
        flexGrow: 1,
    },
    mainContainer: {
        flex: 1,
        
    }
});


class CardUserData extends Component {
    constructor(props){
        super(props);

        console.log("Los PUTOS PROPS")
        console.log(props)
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleShow2 = this.handleShow2.bind(this);
        this.handleClose2 = this.handleClose2.bind(this);
        this.asignarMinMaxMatricula = this.asignarMinMaxMatricula.bind(this);
        this.state = {
           
            show: false,
            show2:false,
            oficiosR: '',
            ri:0,
            rf:0,
            min:0,
            max:0,
          };

         

    }

    componentDidMount(){
       
          this.setState({ oficiosR: this.props.oficiosR})
          console.log("cargand props")
          console.log(this.props)

          
  
        
    }

    handleClose() {
        this.setState({ show: false });
      }
    
      handleShow() {
        this.setState({ show: true });
        console.log("OficiosR")
        console.log(this.state.oficiosR)
      }

      handleClose2() {
        this.setState({ show2: false });
      }
    
      handleShow2() {
        this.setState({ show2: true });
        console.log("OficiosR")
        console.log(this.state.oficiosR)
      }

      areglar(oficios){
        this.setState({ oficiosR: oficios})
      }

      asignarMinMaxMatricula(array) {
        // Verificar si el array no está vacío
        if (array.length === 0) {
            console.error('El array está vacío.');
            return;
        }
    
        // Inicializar las matrículas mínima y máxima con el primer elemento del array
        let minMatricula = array[0].matricula;
        let maxMatricula = array[0].matricula;
    
        array.forEach(item => {
            // Convertir la matrícula a cadena de texto si no lo es
            const matriculaString = typeof item.matricula === 'number' ? String(item.matricula) : item.matricula;
    
            // Verificar si la matrícula es un número o una cadena de texto válida
            if (typeof matriculaString === 'string' || typeof matriculaString === 'number') {
                // Obtener solo el valor numérico de la matrícula
                const matriculaNumerica = parseInt(matriculaString.replace(/\D/g, ''), 10);
    
                // Verificar si la conversión fue exitosa y actualizar minMatricula y maxMatricula
                if (!isNaN(matriculaNumerica)) {
                    if (matriculaNumerica < minMatricula) {
                        minMatricula = matriculaNumerica;
                    }
                    if (matriculaNumerica > maxMatricula) {
                        maxMatricula = matriculaNumerica;
                    }
                } else {
                    console.warn('No se pudo convertir la matrícula a un valor numérico:', matriculaString);
                }
            } else {
                console.warn('La matrícula no es una cadena de texto ni un número:', matriculaString);
            }
        });
    
        // Asignar los valores a this.state.ri y this.state.rf
        this.setState({ ri: minMatricula, rf: maxMatricula, min: minMatricula, max: maxMatricula });
    }
    
    render(){
        const {classes, 

               oficiosR,
          
               buttons,
               onClick,
               usuario,
               iduser,
               indice,
               etiqueta,
               onOEP,
               onOT,
               onR,
               onB,
               tipo,
               id_usuario,
             } = this.props;

     



       


            let br;
            let be;
            if (this.props.indice==0 && this.props.tipo==1){
              br= <Button  style={{marginTop:20,borderRadius:'40px',padding:'0.4em 1.3em',fontSize:'16px',textTransform:'none'}}  onClick={this.handleShow} className="btn btn-success">
            <AddIcon style={{fontSize:'16px'}} className={classes.extendedIcon} /> AÑADIR NUEVO </Button>
            } 

            if (((this.props.indice==3 || this.props.indice==5)  && this.props.tipo==1 ) || ((this.props.indice==1)  && this.props.tipo==2 )){
              be= <Button  style={{marginTop:20,borderRadius:'12px',padding:'0.4em 1.3em',fontSize:'16px',textTransform:'none'}}  onClick={()=>{ this.asignarMinMaxMatricula(this.props.oficiosR); this.handleShow2(); }} className="btn btn-success">
              EMPAQUETAR <MoveToInboxIcon className={classes.extendedIcon} /></Button>
            } 

        return(
        <div className={classes.mainContainer}>
            <Card className={classes.card}>
        
                <CardContent>
                <h3 align="center">{this.props.titulo}</h3>
                
             
               
               
       
                <td> 


                <>
            
      
            <Modal 
           size="xl"
           aria-labelledby="contained-modal-title-vcenter"
           dialogClassName="modal-90w"
           centered
          show={this.state.show} onHide={this.handleClose} style={{marginTop:40}}>
            <Modal.Header closeButton>
            <Modal.Title>PRE REGISTRO </Modal.Title>
            </Modal.Header>
            <Modal.Body>
           
           
            <RegistroOficio id_usuario={usuario} onR={onR}/>
  
          
            </Modal.Body>
            
          </Modal>
        </>


        <>
            
      
            <Modal 
           size="xl"
           aria-labelledby="contained-modal-title-vcenter"
           dialogClassName="modal-90w"
           centered
          show={this.state.show2} onHide={this.handleClose2} style={{marginTop:40}}>
            <Modal.Header closeButton>
            <Modal.Title>EMPAQUETADO {this.props.indice==3 && this.props.tipo==1 ? 'FIRMAS' : this.props.indice==5 ? 'ENTREGAR' : 'PARA ENTREGAR'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
          
            <h4 align="center" >  &nbsp;MATRICULAS  </h4> 
              <hr></hr>
          
              {this.state.show2 ? <Grid container spacing={6} >

<Grid item xs={6}>
            <div className="form-group">
                <label>RANGO INICIAL: </label>
                <input type="number" 
                required
                min={this.state.min}
                max={this.state.max}
                  className="form-control"
                  value={this.state.ri}
                  onChange={(e)=>this.setState({ri:e.target.value})}
                  />
            </div>
          
            </Grid>
            <Grid item xs={6}>
            <div className="form-group">
                <label>RANGO FINAL: </label>
                <input type="number" 
                required
                min={this.state.min}
                max={this.state.max}
                  className="form-control"
                  value={this.state.rf}
                  onChange={(e)=>this.setState({rf:e.target.value})}
                  />
            </div>
          
            </Grid>
            </Grid> : null}
          
            </Modal.Body>
            <Modal.Footer>
          <Button variant='secondary' onClick={()=>this.handleClose2()}>CANCELAR</Button>
          <Button variant='success' onClick={()=>{
            let aa=[]
          

 console.log(this.props.oficiosR);
 this.props.oficiosR.forEach(item1 => {
  // Verificar si matricula es una cadena de texto o un número
  if (typeof item1.matricula === 'string' || typeof item1.matricula === 'number') {
      // Convertir matricula a cadena de texto
      const matriculaString = String(item1.matricula);
      
      // Obtener solo el valor numérico de la matrícula
      const matriculaNumerica = parseInt(matriculaString.replace(/\D/g, ''), 10);

      // Verificar si la conversión fue exitosa
      if (!isNaN(matriculaNumerica)) {
          // Verificar si la matrícula está dentro del rango especificado
          if (matriculaNumerica >= this.state.ri && matriculaNumerica <= this.state.rf) {
              aa.push({
                  id_preregistro: item1.id_preregistro,
                  id_estatus: item1.id_estatus === 3 ? 4 : item1.id_estatus === 4 ? 5 : 6,
                  id_usuario: id_usuario
              });
          }
      } else {
          console.warn('No se pudo convertir la matrícula a un valor numérico:', matriculaString);
      }
  } else {
      console.warn('La matrícula no es una cadena de texto ni un número:', item1.matricula);
  }
});

          console.log(aa);

          aa.forEach(element => {
            UPDCTE(element).then(response => {  


              console.log(response);
             
          
             
                }).catch(err => console.log(err));
          });

          alert(this.props.indice!=5 ? 'ENVIADOS' :'ENTREGADOS');
          window.location.reload();


          }}>{this.props.indice!=5 ? 'ENVIAR' :'ENTREGAR'}</Button>

        </Modal.Footer>
          </Modal>
        </>
                </td>
                <br/>
                      <VentanaPrincipal oficiosR={oficiosR}
        
                      indice={indice}
                      id_usuario={usuario}
                      iduser={iduser}
                      onOEP={onOEP}
                      onOT={onOT}
                      onR={onR}
                      onB={onB}
                      tipo={tipo}
                      id_usuariou={id_usuario}
                      etiqueta={etiqueta}
                      buttons={buttons}
                      onClick={onClick}
                      etiquetaA={this.props.etiquetaA}

                      br={br}
                      be={be}
                      />
                     
                </CardContent>
            </Card>
        </div>
        );
    }
}

CardUserData.propTypes = {
    classes: PropTypes.object.isRequired,
    tableHeader: PropTypes.object.isRequired,
    tableData: PropTypes.object.isRequired,
    oficiosR: PropTypes.object.isRequired,
    handleButtonsEvents: PropTypes.func.isRequired,
    handleRemove: PropTypes.func.isRequired,
    stopEditing: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    editIdx: PropTypes.number.isRequired,
    startEditing: PropTypes.func.isRequired
};

export default withStyles(styles)(CardUserData);